import { forwardRef } from 'react';
import { InputModeOptions, View } from 'react-native';
import { cn } from '../../lib/utils';
import { Typography } from '../Typography/Typography';
import { TextField, TextFieldRef } from './TextField';

export interface TextInputProps {
  value?: string;
  label?: string;
  placeholder?: string;
  onValueChanged?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  autoCapitalize?: boolean;
  readonly?: boolean;
  error?: string;
  className?: string;
  isPassword?: boolean;
  type?: InputModeOptions;
  autoCorrect?: boolean;
  inputIcon?: React.ReactNode;
  onIconPress?: () => void;
}

export const TextInput = forwardRef<TextFieldRef, TextInputProps>(
  (
    {
      value,
      label,
      error,
      placeholder,
      onValueChanged,
      onFocus,
      onBlur,
      readonly,
      className,
      isPassword,
      autoCapitalize,
      autoCorrect,
      type = 'text',
      inputIcon,
      onIconPress,
    },
    ref,
  ) => {
    return (
      <View className="w-full">
        {label && (
          <Typography size="small" className="text-neutral-300 mb-1">
            {label}
          </Typography>
        )}
        <TextField
          isPassword={isPassword}
          onIconPress={onIconPress}
          inputIcon={inputIcon}
          inputMode={type}
          ref={ref}
          fontSize={15}
          fontWeight={400}
          onValueChanged={onValueChanged}
          onFocus={onFocus}
          onBlur={onBlur}
          autoCapitalize={autoCapitalize}
          autoCorrect={autoCorrect}
          value={value}
          className={cn(
            'w-full text-white h-[44px] bg-neutral-500 items-center rounded-lg flex-row px-2 focus:border-2 focus:border-primary',
            error != null &&
              'border-2 border-error focus:border-error text-error',
            className,
          )}
          placeholder={placeholder ?? label ?? ''}
          readOnly={readonly}
        />
        {error && (
          <Typography size="small" className="text-error mt-2">
            {error}
          </Typography>
        )}
      </View>
    );
  },
);
